<template>
  <div class="userInfo">
    <caseInfoModal :caseInfo="caseInfo" @close="showContent=false" @submitData="submitCase" v-if="showContent"></caseInfoModal>
    <mu-flexbox align="flex-start">
      <mu-flexbox-item class="flex-demo">
        <mu-flexbox orient="vertical" style="margin-left:40px;">
          <mu-flexbox-item class="flex-demo">
            <ul>
              <li class="oddStyle">姓名</li>
              <li class="evenStyle">{{caseInfo.name}}</li>
            </ul>
          </mu-flexbox-item>
          <mu-flexbox-item class="flex-demo">
            <ul>
              <li class="oddStyle">年龄</li>
              <li class="evenStyle">{{caseInfo.age}}岁</li>
            </ul>
          </mu-flexbox-item>
          <mu-flexbox-item class="flex-demo">
            <ul>
              <li class="oddStyle">性别</li>
              <li class="evenStyle">{{sex}}</li>
            </ul>
          </mu-flexbox-item>
          <mu-flexbox-item class="flex-demo">
            <ul>
              <li class="oddStyle">教育程度</li>
              <li class="evenStyle">{{edu}}</li>
            </ul>
          </mu-flexbox-item>

          <mu-flexbox-item class="flex-demo">
            <span class="pointer changeStyle" @click="showCaseModal">信息有误，点击修改</span>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-flexbox-item>
      <mu-flexbox-item>
        <mu-flexbox orient="vertical" style="margin-left:60px;">
          <mu-flexbox-item class="flex-demo">
            <ul>
              <li class="oddStyle">手机号/账号</li>
              <li class="evenStyle">{{caseInfo.username}}</li>
            </ul>
          </mu-flexbox-item>
          <mu-flexbox-item class="flex-demo">
            <ul>
              <li class="oddStyle">初始密码</li>
              <li class="evenStyle" style="width:200px">
                <span>123456</span>
                <span @click='openResetAlert' style='color:#449ad0;text-decoration:underline;font-weight:400;cursor:pointer'> 重置为初始密码</span>
              </li>
            </ul>
          </mu-flexbox-item>

          <mu-flexbox-item class="flex-demo">
            <ul>
              <li class="oddStyle">添加人</li>
              <li class="evenStyle">{{caseInfo.addUser}}</li>
            </ul>
          </mu-flexbox-item>
          <mu-flexbox-item>&nbsp;</mu-flexbox-item>
          <mu-flexbox-item>&nbsp;</mu-flexbox-item>
          <mu-flexbox-item>&nbsp;</mu-flexbox-item>
        </mu-flexbox>
      </mu-flexbox-item>
      <mu-flexbox-item>
        <mu-flexbox orient="vertical" align="flex-start">
          <mu-flexbox-item class="flex-demo">
            <printInfo :caseInfo="caseInfo" v-if="showModal" @close="closePrint"></printInfo>
          </mu-flexbox-item>
        </mu-flexbox>
        <mu-flexbox orient="vertical" align="flex-start">
          <mu-flexbox-item class="flex-demo">
            <mu-raised-button label="打印账号" @click="openPrint" class="btnprintClass" primary/>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-flexbox-item>
    </mu-flexbox>
    <mu-dialog  width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="resetAlert">
      确认要重置患者密码为初始密码吗？
      <mu-raised-button flat label="取消" @click="closeResetAlert"  slot="actions"  primary/>
      <mu-raised-button flat label="确认" @click="agree"  slot="actions"  primary/>
    </mu-dialog>
  </div>
</template>
<script>
  import Vue from 'vue'
  import caseInfoModal from './caseInfoModal.vue'
  import printInfo from './printInfo.vue'
  import {getSelect,date2Str} from '../../../../assets/js/common.js'

  export default ({
    props: ['caseInfo'],
    data() {
      return {
        showContent: false,
        showModal:false,
        resetAlert:false
      }
    },
    computed: {
      sex: function() {
        return getSelect('gender', this.caseInfo.gender)
      },
      edu: function(){
        if(this.caseInfo.education && this.caseInfo.education != '0') {
          return getSelect('edus', this.caseInfo.education);
        } else {
          return '暂无';
        }
      },
      handup: function(){
        if(this.caseInfo.hand){
          return getSelect('hands', this.caseInfo.hand)
        } else {
          return '暂无';
        }
      }
    },
    components:{
      caseInfoModal,
      printInfo,
    },
    methods: {
      closePrint(){
        this.showModal = false;
      },
      openPrint:function(){
        this.showModal = true;
      },
      showCaseModal: function(){
        this.showContent = true;
      },
      submitCase: function(){
        this.showContent = false;
        location.reload();
      },
      openResetAlert:function(){
          this.resetAlert = true
      },
      closeResetAlert:function(){
        this.resetAlert = false;
        console.log(this.caseInfo)
      },
      agree:function(){
        var self = this;
        self.resetAlert = false;
        self.$http.post('/api/Users/resetPassword',{
          "mobile":self.caseInfo.username,
          "password":"123456"},
          {emulateJSON:true}
      ).then(
        function(res){
      },
      function(err){
        if(err){console.log(err)}
      }
      )}
    }
  })
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import "../../../../assets/css/app.styl"
  @import "../../../../assets/css/variable.styl"
  @import "../../../../assets/css/table.styl"

  .userInfo
    margin-top 20px
  .flex-demo
    ul
      height 70px
</style>



// WEBPACK FOOTER //
// caseinfo.vue?41406c45